<header class="row">
  <div class="col-12 px-3 px-lg-4 h-100 d-flex justify-content-between align-items-center">
    <div class="h1 mb-0"><ng-content></ng-content></div>
      <div class="d-flex flex-row">
    <app-help-content [key]='key' class="mx-2"></app-help-content>
    <app-language-switch class="ml-2"></app-language-switch>
      </div>
  </div>
</header>
